import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewbox="0 0 24 24" fill="none"><path fill="currentColor" d="M11.053 21.46a9.485 9.485 0 0 1-4.219-1.495c-1.066-.695-1.307-.981-1.307-1.552 0-1.146 1.26-3.153 3.418-5.442 1.226-1.3 2.932-2.823 3.117-2.782.358.08 3.227 2.877 4.3 4.194 1.699 2.081 2.48 3.786 2.083 4.546-.301.577-2.172 1.707-3.546 2.14-1.133.358-2.62.51-3.846.392Zm-6.967-4.238c-.886-1.36-1.334-2.697-1.55-4.632-.071-.64-.046-1.005.162-2.316.26-1.635 1.19-3.526 2.31-4.69.476-.496.519-.508 1.1-.312.706.237 1.46.758 2.628 1.814l.682.616-.373.457c-1.728 2.122-3.553 5.13-4.24 6.991-.374 1.012-.525 2.027-.364 2.45.109.286.009.18-.355-.378Zm15.559.23c.087-.426-.024-1.21-.283-2.002-.562-1.714-2.441-4.902-4.166-7.07l-.544-.682.588-.54c.767-.704 1.3-1.125 1.875-1.483.453-.283 1.101-.533 1.38-.533.172 0 .776.627 1.264 1.312a9.94 9.94 0 0 1 1.595 3.683c.182.864.197 2.714.029 3.577a11.272 11.272 0 0 1-.713 2.248c-.212.466-.741 1.372-.973 1.667-.12.151-.12.15-.052-.176ZM11.209 4.819c-.796-.404-2.024-.837-2.702-.954a4.953 4.953 0 0 0-.902-.05c-.56.028-.534-.002.363-.426a9.236 9.236 0 0 1 2.215-.737c.95-.2 2.738-.202 3.674-.005 1.01.213 2.2.656 2.872 1.068l.199.123-.457-.023c-.91-.046-2.234.32-3.656 1.013-.428.208-.802.375-.829.37a14.518 14.518 0 0 1-.777-.379Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
